import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";
import * as Rails from "@rails/ujs";

export default class extends Controller {
  static values = {
    delay: Number,
  };

  initialize() {
    this.save = this.save.bind(this);
  }

  connect() {
    if (this.delayValue > 0) {
      this.save = debounce(this.save, this.delayValue);
    }
  }

  disconnect() {
    this.save.cancel();
  }

  save() {
    if (!window._rails_loaded) return;
    document
      .querySelectorAll(".alert-danger")
      .forEach((el) => el.classList.add("d-none"));
    document
      .querySelectorAll(".is-invalid")
      .forEach((el) => el.classList.remove("is-invalid"));
    document.querySelectorAll(".invalid-feedback").forEach((e) => e.remove());
    Rails.fire(this.element, "submit");
  }
}
